const ANALYTICS_OWNER_IDENTITY = 'postmaster@analytics.msging.net';
const RD_STATION_TOKEN_URI = '/rdstation/token';
const RD_STATION_ACCOUNT_URI = '/rdstation/account';
// Services
export class RdStationService {
    static $inject = ['MessagingHubService'];
    constructor(MessagingHubService) {
        this.MessagingHubService = MessagingHubService;
    }
    async getAccountDetails() {
        const accountCommandRequest = {
            method: 'get',
            to: ANALYTICS_OWNER_IDENTITY,
            uri: RD_STATION_ACCOUNT_URI,
        };
        const commandResponse = await this.MessagingHubService.processCommand(accountCommandRequest);
        return this.MessagingHubService.ensureCommandSuccess(commandResponse);
    }
    async createToken(code) {
        const createTokenCommandRequest = {
            method: 'set',
            type: 'application/vnd.iris.rdstation.authorization-code',
            to: ANALYTICS_OWNER_IDENTITY,
            uri: RD_STATION_TOKEN_URI,
            resource: code,
        };
        const commandResponse = await this.MessagingHubService.processCommand(createTokenCommandRequest);
        return this.MessagingHubService.ensureCommandSuccess(commandResponse);
    }
    async revokeToken() {
        const uninstallIntegrationCommandRequest = {
            method: 'delete',
            to: ANALYTICS_OWNER_IDENTITY,
            uri: RD_STATION_TOKEN_URI,
        };
        const commandResponse = await this.MessagingHubService.processCommand(uninstallIntegrationCommandRequest);
        return this.MessagingHubService.ensureCommandSuccess(commandResponse);
    }
}
RdStationService.$inject = ['MessagingHubService'];
